import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@wix/da-ds/pkg/Icons/24x24/Check';
import Notification from '../Notifications/Notification';
import SystemNotification from '../SystemNotification';
import s from './DeviationUnpublishedNotification.scss';
const DeviationUnpublishedNotification = ({ id, queueName, deviation })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(Notification, {
        id: id,
        queueName: queueName,
        cardComponent: SystemNotification,
        cardProps: {
            backgroundDeviation: deviation,
            iconComponent: CheckIcon,
            actions: [
                {
                    label: t('unpublish.notification.success.cta'),
                    href: deviation.url
                }
            ]
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['text']
    }, t(`unpublish.notification.success.text`)));
};
DeviationUnpublishedNotification.displayName = 'DeviationUnpublishedNotification';
export default DeviationUnpublishedNotification;

//# sourceMappingURL=DeviationUnpublishedNotification.js.map